<template>
  <v-card>
    <v-row wrap>
      <v-col cols="12" md="8" lg="6" offset-md="2" offset-lg="3">
        <div class="box mb-5">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header"
          >
            <v-flex xs12>
              <h2 class="box-header-item mb-3 mb-md-0">{{ $t('lostpassword-screen.title') }}</h2>
            </v-flex>
          </v-layout>

          <div class="box-content">
            <v-form
              v-model="valid"
              @submit.prevent="forgotPassword('json')"
            >
              <v-container>

                <v-alert
                  v-model="alert"
                  :type="alertType"
                >
                  {{ alertMessage }}
                </v-alert>

                <v-flex xs12 class="mb-4">
                  <!-- login -->
                  <v-text-field
                    v-if="check"
                    v-model="loginName"
                    :label="$t('lostpassword-screen.label-1')"
                    required
                    aria-required
                    class="mandatory"
                    outlined
                  ></v-text-field><!-- login -->

                  <v-text-field
                    v-if="!check"
                    v-model="email"
                    :rules="[rules.email]"
                    :label="$t('lostpassword-screen.label-2')"
                    required
                    aria-required
                    class="mandatory"
                    outlined
                  ></v-text-field>
                </v-flex>

                <!-- submit -->
                <div class="text-center">
                  <v-btn
                    v-if="check"
                    :elevation="0"
                    rounded
                    outlined
                    color="primary"
                    @click.prevent="forgotPassword('json+check')"
                    v-html="$t('lostpassword-screen.btn-1')"
                    :disabled="loginName ? false : true"
                  ></v-btn>
                  <v-btn
                    v-else-if="!check"
                    :elevation="0"
                    rounded
                    outlined
                    color="primary"
                    @click.prevent="forgotPassword('json+check')"
                    v-html="$t('lostpassword-screen.btn-2')"
                    :rules="[rules.email]"
                    :disabled="email && emailReg.test(email) ? false : true"
                  ></v-btn>
                  <span class="px-3"></span>
                  <v-btn
                    :elevation="0"
                    rounded
                    color="primary"
                    type="submit"
                    :disabled="loginName || (email && emailReg.test(email)) ? false : true"
                    v-html="$t('lostpassword-screen.cta')"
                  ></v-btn>
                </div>

              </v-container>
            </v-form>
          </div><!-- box-content -->
        </div><!-- box -->
        <div class="text-center">
          <!-- <a @click.prevent="changeCheckStatement" class="link">
            <template v-if="check">{{ $t('lostpassword-screen.link-1') }}</template>
            <template v-if="!check">{{ $t('lostpassword-screen.link-2') }}</template>
          </a>
          <span class="px-3"></span> -->
          <router-link class="link" to="/">{{ $t('lostpassword-screen.link-3') }}</router-link>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { resetPassword } from '@/js/auth/forgotPassword'

export default {
  data () {
    return {
      alert: false,
      alertType: 'error',
      alertMessage: this.$t('basic-message.error-message'),

      // form model
      check: false,
      valid: false,
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      rules: {
        // required: value => !!value || 'Required.',
        email: value => {
          if (value === '') return true
          const reg = this.emailReg
          return reg.test(value) || this.$t('rules-field.email')
        }
      },

      // text-field: key
      loginName: '',

      // text-field: email
      email: ''
    }
  },
  methods: {
    changeCheckStatement () {
      this.loginName = ''
      this.email = ''
      this.alert = false
      this.check = !this.check
    },

    forgotPassword (options) {
      const { loginName, email } = this
      const params = { // escape uri params
        options: options,
        loginName: loginName,
        email: email
      }
      resetPassword(params, this.$i18n)
        .then(response => {
          this.alert = response.alert
          this.alertType = response.alertType
          this.alertMessage = response.alertMessage
        })
        .catch(error => {
          this.alert = error.alert
          this.alertType = error.alertType
          this.alertMessage = error.alertMessage
        })
    }
  }
}
/* eslint-disable */
</script>

<style scoped>

.v-card {
  min-height: 300px;
  margin-bottom: 30px;
}

</style>
